///<reference path='../../../../shared/xlsx.d.ts'/>

import { Injectable } from '@angular/core';
import { read, utils } from 'xlsx';

@Injectable()
export class ExcelParser {
    public async parseFile(file: File): Promise<any[][]> {
        const fileContent = await this.readFileAsBinaryString(file);

        const workBook = read(fileContent, { type: 'binary' });
        const firstSheet = workBook.Sheets[workBook.SheetNames[0]];
        const sheetRows = utils.sheet_to_json<any[]>(firstSheet, { header: 1, raw: false });

        return sheetRows;
    }

    private readFileAsBinaryString = (file: File): Promise<string> => {
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
            reader.onerror = () => {
                reader.abort();
                reject(new DOMException('Problem parsing input file.'));
            };

            reader.onload = () => {
                resolve(reader.result as string);
            };

            reader.readAsBinaryString(file);
        });
    }
}
